module.exports = __webpack_public_path__ + "img/lan_tour_route_07.65301c30.jpg";